export default __webpack_public_path__ + "static/media/auth2.3ea02507.jpg";